import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import DatePicker from '../Common/datePicker';
import InputField from '../Common/inputField';
import { Grid, Row, Col, Panel, Button, Table, Input } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

class InventoryAdjustmentForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            adjustment_id: 0,

            inventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            },

            adjustedInventories: {
                rows: [],
                selectedRows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const { currentInventoryAdjustment } = this.props;
        if(currentInventoryAdjustment) {
          this.props.fetchInventoryAdjustmentDetail(currentInventoryAdjustment.WarehouseAdjustment_id)
            .then(() => {
              this.props.fetchInventories();
            });
        }
        this.props.fetchInventories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if(nextProps.currentInventoryAdjustmentDetail && nextProps.currentInventoryAdjustmentDetail != this.props.currentInventoryAdjustmentDetail) {
          let adjustment_id = 0;
          let warehouse_Adjustment_Line = nextProps.currentInventoryAdjustmentDetail.Warehouse_Adjustment_Line;
          warehouse_Adjustment_Line.map(adjustmentLine => {
            adjustmentLine["adjustment_id"] = adjustment_id;
            adjustment_id = adjustment_id+1;
            adjustmentLine.ZoneName = adjustmentLine.WarehouseZone_id.Name;
            adjustmentLine.BinName = adjustmentLine.WarehouseBin_id.Name;
          });
          const adjustedInventories = {...this.state.adjustedInventories, rows: warehouse_Adjustment_Line};

          this.setState({adjustedInventories: adjustedInventories, adjustment_id: adjustment_id});
        }
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
          let newInventories = [];
          newInventories = nextProps.inventories;
          const inventories = {...this.state.inventories, rows: newInventories }
            this.setState({
                inventories: inventories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    setInventoryToAdjust(e) {
        e.preventDefault();
        const { inventories, adjustedInventories } = this.state;
        let adjustment_id = this.state.adjustment_id;
        let inventoryToLocate = { ...inventories.selectedRows[0],
            ToZone: this.props.toZoneValue,
            ToBin: this.props.toBinValue,
            Quantity: this.props.quantityValue,
            adjustment_id: adjustment_id,
            isSelected: false
            // newQuantity: inventories.selectedRows[0].Quantity + this.props.quantityValue
            // NewQuantity: this.props.quantityValue
        };
        adjustment_id = adjustment_id+1;
        let newAdjustedInventories = { ...adjustedInventories };
        const newInventories = { ...inventories };
        newAdjustedInventories.rows.push(inventoryToLocate);

        // const index = _.findIndex(inventories.rows, { 'Vendor_id': inventories.selectedRows[0].Vendor_id });
        // if (index > -1) {
        //     newInventories.rows.splice(index, 1);
        // }
        // newInventories.selectedRows = [];
        this.setState({
            adjustedInventories: newAdjustedInventories,
            adjustment_id: adjustment_id
        })
    }

    cancelInventoryAdjustment(e) {
        e.preventDefault();
        const { inventories, adjustedInventories } = this.state;
        // const inventoryToCancel = { ...adjustedInventories.selectedRows[0] };
        let newAdjustedInventoriesRows = [...adjustedInventories.rows ];
        // const newInventories = { ...inventories };
        // newInventories.rows.push(inventoryToCancel)

        newAdjustedInventoriesRows = newAdjustedInventoriesRows.filter(function(obj){
              return obj.isSelected == false || obj.isSelected == null;
            })

        let newAdjustedInventories = { ...adjustedInventories, rows: newAdjustedInventoriesRows};
        // newAdjustedInventories.selectedRows = [];
        this.setState({
            adjustedInventories: newAdjustedInventories
        })
    }

    createAdjustment(e) {
      e.preventDefault();
      if(this.props.currentInventoryAdjustmentDetail) {
        if(!this.checkPermission("change_warehouse_adjustment"))
          this.props.editInventoryAdjustment(
            this.props.currentInventoryAdjustmentDetail.WarehouseAdjustment_id,
            1,
            this.props.postingDate,
            this.props.note,
            Data.Selectors.getRows(this.state.adjustedInventories)
          );
        else
          alert("You have no permission!");
      }
      else
        this.props.createInventoryAdjustment(
          1,
          this.props.postingDate,
          this.props.note,
          Data.Selectors.getRows(this.state.adjustedInventories)
        );
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ inventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const inventories = {...this.state.inventories, filters: newFilters }
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                const inventories = {...this.state.inventories, selectedRows: rows }
                this.setState({ inventories });
            }

            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });
            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductUnitOfMeasure',
                    name: <Translate value="unit_of_measure" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Pallet',
                    name: <Translate value="pallet" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinAmount',
                    name: <Translate value="bin_amount" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ZoneName',
                    name: <Translate value="zone_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'BinName',
                    name: <Translate value="bin_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Batch_PONum',
                    name: <Translate value="batch_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ExpiredDate',
                    name: <Translate value="expired_date" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryAdjustmentForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }
    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderAdjustedTable() {
        if (this.props.vendorIsLoading && !this.props.vendorError) return <Spinner/>
        else if (this.props.vendorError) return <ContentWrapper><div className="alert alert-danger">{this.props.vendorError}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.adjustedInventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var adjustedInventories = {...this.state.adjustedInventories, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({ adjustedInventories: adjustedInventories });
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.adjustedInventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const adjustedInventories = {...this.state.adjustedInventories, filters: newFilters }
                this.setState({ adjustedInventories: adjustedInventories });
            }

            // Handle the Dragable cell function

            const handleCellDrag = e => {
                let { adjustedInventories } = this.state
                let rows = adjustedInventories.rows.slice(0);
                for (let i = e.fromRow; i <= e.toRow; i++) {
                    let rowToUpdate = rows[i];
                    rowToUpdate[e.cellKey] = e.value;
                }
                const newAdjustedInventories = {...adjustedInventories, rows: rows }
                this.setState({
                    adjustedInventories: newAdjustedInventories
                });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let { adjustedInventories } = this.state
                let rows = getRows();
                Object.assign(rows[e.rowIdx], e.updated);
                const newAdjustedInventories = {...adjustedInventories, rows: rows }
                this.setState({
                    adjustedInventories: newAdjustedInventories,
                });
            }

            // Handle the row select function

            // const onRowSelect = rows => {
            //     const adjustedInventories = {...this.state.adjustedInventories, selectedRows: rows };
            //     this.setState({ adjustedInventories: adjustedInventories });
            // }

            const onRowsSelected = (rows) => {
                         let newRows = this.state.adjustedInventories.rows;
                         rows.map (r => {
                           newRows[r.rowIdx].isSelected = true;
                         });
                         var adjustedInventories = {...this.state.adjustedInventories, rows: newRows}
                         this.setState({adjustedInventories});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = this.state.adjustedInventories.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 // var rowIndexes = rows.map(r => r.rowIdx);
                 var adjustedInventories = {...this.state.adjustedInventories, rows: newRows};
                 this.setState({adjustedInventories});
             }


            //Custom Formatter component

            const NameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Quantity',
                    name: <Translate value="adjustment_quantity" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'ZoneName',
                    name: <Translate value="zone_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    editable: true
                },
                {
                    key: 'BinName',
                    name: <Translate value="bin_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    editable: true
                }
            ]


            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryAdjustmentForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='adjustment_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={200}
                        enableRowSelect='single'
                        onCellsDragged={handleCellDrag}
                        enableCellSelect={true}
                        onRowUpdated={handleRowUpdated}
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}

                        />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        const inventoryAdjustmentWarehouseLocation = (<Translate value="inventory_adjust_warehouse_loc" />);
        const inventoryAdjustmentSheetWarehouseLoc = (<Translate value="inventory_adjust_sheet_warehouse_loc" />);
        const { inventories, adjustedInventories } = this.state;
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="inventory_adjustment" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories/adjustment"  className="btn btn-green buttonStyle"><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                        <button
                          className="btn btn-primary buttonStyle"
                          onClick={(e) => this.createAdjustment(e) }>
                          <em className="fa fa-save marginRightStyle"/><Translate value="save" /></button>
                    </div>
                </Col></Row>
              <Row className="marginTopStyle">
                    <Col sm={ 12 }>
                        <Panel header={inventoryAdjustmentWarehouseLocation}>
                            <h4><Translate value="current_inventory" /></h4>
                            <hr/>
                            <p><Translate value="msg_select_an_inventory_to_adjust" /></p>
                            {this.renderTable() }
                            <h4 className="marginTopStyleLarge"><Translate value="adjustment" /></h4>
                            <hr/>
                            <p><Translate value="adjust_some_or_all_of_the_selected_inventory" /></p>
                            <Row>
                                <Col sm={ 6 }>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_num" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductNum : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="product_name" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductName : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="package_type" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ProductUnitOfMeasure : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="batch_num" /> (<Translate value="po_num" />)</label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].Batch_PONum : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_zone" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].ZoneName : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6}><label><Translate value="current_bin" /></label></Col>
                                        <Col sm={6}>{inventories.selectedRows[0] ? inventories.selectedRows[0].BinName : <Translate value="please_select_inventory" />}</Col>
                                    </Row>
                                </Col>
                                <Col sm={ 6 }>
                                    <Row><Col sm={ 12 }><label><Translate value="adjustment_quantity" /></label></Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <Field component={InputField} name="Quantity"></Field>
                                    </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        {inventories.selectedRows[0] &&
                                            parseInt(this.props.quantityValue) > parseInt(inventories.selectedRows[0].CreditStatus) &&
                                            <p className="parsley-error-message"><Translate value="msg_relocation_qty_cannot_exceed_current_qty" /></p>}
                                    </Col></Row>
                                    <button
                                        className="btn btn-primary pull-right"
                                        onClick={(e) => this.setInventoryToAdjust(e) }
                                        disabled={ !inventories.selectedRows[0]}><Translate value="submit" /></button>
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header={inventoryAdjustmentSheetWarehouseLoc}>
                            <h4><Translate value="inventory_adjustment_sheet" /></h4>
                            <hr/>
                            <p><Translate value="list_of_adjustment_lines" /></p>
                            {this.renderAdjustedTable() }
                            <button
                                className="btn btn-warning pull-right marginTopStyle"
                                onClick={(e) => this.cancelInventoryAdjustment(e) }
                                ><Translate value="cancel" /></button>
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <Col sm={ 7 }>
                        <Col sm={ 6 }><Translate value="adjustment_date" />: </Col>
                        <Col sm={ 6 } className="marginBottomStyle">
                            <Field component={DatePicker} name="PostingDate"></Field>
                        </Col>
                        <Col sm={ 6 }><Translate value="modifier" />: </Col>
                        <Col sm={ 6 }>
                            <Field component={InputField} name="Modify_Username"></Field>
                        </Col>
                        <Col sm={ 3 }><Translate value="note" />: </Col>
                        <Col sm={ 9 }>
                            <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                        </Col>
                    </Col>
                </Row>
                <br/>
            </ContentWrapper>
        );
    }
}



export default InventoryAdjustmentForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryAdjustmentForm.jsx